import { HttpRequest } from '../shared/http-request';
import { HttpResponse } from '../shared/http-response';
import { Observable } from 'rxjs/Observable';

export abstract class ServiceProxyBase {
    //abstract get<T1, T2>(request: HttpRequest<T1>): Observable<HttpResponse<T2>> ;
    abstract post<T1, T2>(request: HttpRequest<T1>): Observable<HttpResponse<T2>> ;
    // abstract put<T1, T2>(request: HttpRequest<T1>): Observable<HttpResponse<T2>> ;

}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/service-proxy-base.ts